export const CHAT_HISTORY_WINDOW = 12;
